var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M1.18374 9.90888C0.939972 9.92306 0.700234 9.84202 0.51508 9.68285C0.149921 9.31552 0.149921 8.72226 0.51508 8.35493L8.51086 0.359114C8.89066 0.00372499 9.48662 0.0234809 9.84201 0.403278C10.1634 0.746727 10.1821 1.27462 9.88587 1.63996L1.84298 9.68285C1.66021 9.83972 1.42432 9.92061 1.18374 9.90888Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.17011 9.90879C8.92305 9.90774 8.68626 9.80967 8.51085 9.63568L0.515032 1.63984C0.176731 1.24478 0.222725 0.650245 0.617782 0.311913C0.97038 0.00996116 1.49039 0.00996116 1.84296 0.311913L9.88585 8.30773C10.2656 8.66321 10.2852 9.2592 9.9297 9.63891C9.91556 9.65401 9.90096 9.66862 9.88585 9.68276C9.68891 9.85402 9.42973 9.93587 9.17011 9.90879Z",
    fill: "#6A6A6A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.a6f9962cb33ddaccea47b2b33569245a.svg";
export { ForwardRef as ReactComponent };